import { baseBackend } from "../../../api/base/baseUrl";

const URL_MANIFEST = "/api/v1/module/manifest";

export const ReadScheduledManifest = async (id) => {
  return await baseBackend.get(`${URL_MANIFEST}/read/list/scheduled/${id}`, {
    headers: { "Content-Type": "application/json" },
  });
};
